/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/**
 * Vanilla extend function.
 *
 * @link http://youmightnotneedjquery.com/
 *
 * @param  {Object} out
 * @return {Object}
 */
export const deepExtend = (out) => {
	out = out || {};

	for (let i = 1; i < arguments.length; i++) {
		const obj = arguments[i];

		if (!obj) {
			// eslint-disable-next-line no-continue
			continue;
		}

		// eslint-disable-next-line no-restricted-syntax
		for (const key in obj) {
			// eslint-disable-next-line no-prototype-builtins
			if (obj.hasOwnProperty(key)) {
				if (typeof obj[key] === 'object') {
					out[key] = deepExtend(out[key], obj[key]);
				} else {
					out[key] = obj[key];
				}
			}
		}
	}

	return out;
};

export const slideUp = (target, duration = 300) => {
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = `${duration}ms`;
	target.style.height = `${target.offsetHeight}px`;
	target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	window.setTimeout(() => {
		target.style.display = 'none';
		target.style.removeProperty('height');
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
		// alert("!");
	}, duration);
};

export const slideDown = (target, duration = 300) => {
	target.style.removeProperty('display');
	let { display } = window.getComputedStyle(target);

	if (display === 'none') { display = 'block'; }

	target.style.display = display;
	const height = target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight;
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = `${duration}ms`;
	target.style.height = `${height}px`;
	target.style.removeProperty('padding-top');
	target.style.removeProperty('padding-bottom');
	target.style.removeProperty('margin-top');
	target.style.removeProperty('margin-bottom');
	window.setTimeout(() => {
		target.style.removeProperty('height');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
	}, duration);
};

export const slideToggle = (target, duration = 300) => {
	if (window.getComputedStyle(target).display === 'none') {
		return slideDown(target, duration);
	}
	return slideUp(target, duration);
};
